import { MessageSquareText, Phone } from "lucide-react";
import { BUSINESS } from "../lib/site";

export const StickyCall = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/15 md:hidden"
    data-testid="sticky-call-bar"
  >
    <a
      href={BUSINESS.phoneTel}
      className="flex items-center justify-center gap-2 bg-ves-green py-3.5 font-heading text-sm font-black tracking-wide text-ves-black"
      data-testid="sticky-call-button"
    >
      <Phone className="h-4 w-4" /> CALL NOW
    </a>
    <a
      href={BUSINESS.sms}
      className="flex items-center justify-center gap-2 bg-ves-charcoal py-3.5 font-heading text-sm font-black tracking-wide text-white"
      data-testid="sticky-text-button"
    >
      <MessageSquareText className="h-4 w-4 text-ves-green" /> TEXT PHOTOS
    </a>
  </div>
);
